// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__D4h5E {
  width: var(--PAGE_MAX_WIDTH);
  min-height: max-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--COLOR_FOREGROUND);
  border-radius: var(--RADIUS_12);
}

.styles_headerBlock__C4EzN {
  width: 100%;
  display: flex;
  align-items: center;
  padding: var(--PADDING_24);
}

.styles_titleStyle__-Q4Da {
  font-family: var(--FONT_SEMIBOLD);
  font-style: normal;
  font-weight: var(--WEIGHT_600);
  font-size: var(--FONT_SIZE_TEXT_TITLE);
  line-height: var(--LINE_HEIGHT_28);
}

.styles_mainBlock__yrN1\\+ {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: var(--PADDING_8) var(--PADDING_24);
}

.styles_selectMenuBlock__2EThA {
  width: 100%;
  height: max-content;
  border-radius: var(--RADIUS_8);
  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT),
    0 0 0 var(--SIZE_4) var(--COLOR_PRIMARY_100);
}

.styles_footerBlock__NTbkT {
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: var(--PADDING_24);
}

.styles_buttonCancelStyle__shjOG {
  width: 100%;
  padding-right: var(--PADDING_12);
}

.styles_buttonCreateStyle__28uKF {
  width: 100%;
}

.styles_menuTitleText__9XX\\+P {
  padding-bottom: var(--PADDING_6);
  font-family: var(--FONT_MEDIUM);
  font-style: normal;
  font-weight: var(--WEIGHT_NORMAL);
  font-size: var(--FONT_SIZE_TEXT);
  line-height: var(--LINE_HEIGHT_20);
  color: var(--COLOR_PRIMARY_950);
  margin-top: var(--MARGIN_12);
}

.styles_addLablesInputStyle__qBrAf {
  margin-bottom: var(--MARGIN_12);
  padding: var(--PADDING_10) var(--PADDING_14);
  height: var(--SIZE_44);
  font-family: var(--FONT_DEFAULT);
  font-style: normal;
  font-weight: var(--WEIGHT_400);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  line-height: var(--LINE_HEIGHT_24);
  color: var(--COLOR_GRAY_900);
  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT);
}

.styles_addLablesInputStyle__qBrAf::placeholder {
  font-family: var(--FONT_DEFAULT);
  font-style: normal;
  font-weight: var(--WEIGHT_400);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  line-height: var(--LINE_HEIGHT_24);
  color: var(--COLOR_GRAY_500);
}

.styles_addLablesBlock__be0dj {
  margin-bottom: var(--MARGIN_24);
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/modals/OrgUsersModal/styles.module.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,8BAA8B;EAC9B,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B;gDAC8C;AAChD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,kCAAkC;EAClC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;EAC5C,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,kCAAkC;EAClC,4BAA4B;EAC5B,qEAAqE;AACvE;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":[".container {\n  width: var(--PAGE_MAX_WIDTH);\n  min-height: max-content;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: var(--COLOR_FOREGROUND);\n  border-radius: var(--RADIUS_12);\n}\n\n.headerBlock {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  padding: var(--PADDING_24);\n}\n\n.titleStyle {\n  font-family: var(--FONT_SEMIBOLD);\n  font-style: normal;\n  font-weight: var(--WEIGHT_600);\n  font-size: var(--FONT_SIZE_TEXT_TITLE);\n  line-height: var(--LINE_HEIGHT_28);\n}\n\n.mainBlock {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: var(--PADDING_8) var(--PADDING_24);\n}\n\n.selectMenuBlock {\n  width: 100%;\n  height: max-content;\n  border-radius: var(--RADIUS_8);\n  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT),\n    0 0 0 var(--SIZE_4) var(--COLOR_PRIMARY_100);\n}\n\n.footerBlock {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  padding: var(--PADDING_24);\n}\n\n.buttonCancelStyle {\n  width: 100%;\n  padding-right: var(--PADDING_12);\n}\n\n.buttonCreateStyle {\n  width: 100%;\n}\n\n.menuTitleText {\n  padding-bottom: var(--PADDING_6);\n  font-family: var(--FONT_MEDIUM);\n  font-style: normal;\n  font-weight: var(--WEIGHT_NORMAL);\n  font-size: var(--FONT_SIZE_TEXT);\n  line-height: var(--LINE_HEIGHT_20);\n  color: var(--COLOR_PRIMARY_950);\n  margin-top: var(--MARGIN_12);\n}\n\n.addLablesInputStyle {\n  margin-bottom: var(--MARGIN_12);\n  padding: var(--PADDING_10) var(--PADDING_14);\n  height: var(--SIZE_44);\n  font-family: var(--FONT_DEFAULT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_400);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  line-height: var(--LINE_HEIGHT_24);\n  color: var(--COLOR_GRAY_900);\n  box-shadow: 0 var(--SIZE_1) var(--SIZE_2) var(--COLOR_GRAY_900_LIGHT);\n}\n\n.addLablesInputStyle::placeholder {\n  font-family: var(--FONT_DEFAULT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_400);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  line-height: var(--LINE_HEIGHT_24);\n  color: var(--COLOR_GRAY_500);\n}\n\n.addLablesBlock {\n  margin-bottom: var(--MARGIN_24);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__D4h5E`,
	"headerBlock": `styles_headerBlock__C4EzN`,
	"titleStyle": `styles_titleStyle__-Q4Da`,
	"mainBlock": `styles_mainBlock__yrN1+`,
	"selectMenuBlock": `styles_selectMenuBlock__2EThA`,
	"footerBlock": `styles_footerBlock__NTbkT`,
	"buttonCancelStyle": `styles_buttonCancelStyle__shjOG`,
	"buttonCreateStyle": `styles_buttonCreateStyle__28uKF`,
	"menuTitleText": `styles_menuTitleText__9XX+P`,
	"addLablesInputStyle": `styles_addLablesInputStyle__qBrAf`,
	"addLablesBlock": `styles_addLablesBlock__be0dj`
};
export default ___CSS_LOADER_EXPORT___;
